// extracted by mini-css-extract-plugin
export var avatarContainer = "_t-0";
export var avatarTypingWave = "_t-i";
export var gray = "_t-f";
export var green = "_t-c";
export var icon = "_t-9";
export var image = "_t-1";
export var lg = "_t-6";
export var md = "_t-5";
export var presenceDot = "_t-b";
export var red = "_t-d";
export var sm = "_t-4";
export var status = "_t-a";
export var typingDot = "_t-h";
export var typingPill = "_t-g";
export var xl = "_t-7";
export var xs = "_t-3";
export var xxl = "_t-8";
export var xxs = "_t-2";
export var yellow = "_t-e";